import styled from "@emotion/styled";

import { theme } from "../../../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const Root = styled.a<{ disabled?: boolean }>(
    _ => ({
        display: "inline-block",
        borderRadius: "50%",
        height: 20,
        width: 20,
        lineHeight: "20px",
        textAlign: "center",
    }),
    props =>
        props.disabled
            ? {
                  color: theme(props).icons.disabledColor,
              }
            : {
                  color: theme(props).lists.items.default.secondaryColor,

                  ":hover": {
                      color: theme(props).typography.primary.color,
                      backgroundColor: theme(props).keyPalette.panel2BackgroundColorAsBlackTransparent,
                  },
              }
);
